import { render, staticRenderFns } from "./imports copy.vue?vue&type=template&id=3dc09292&scoped=true&"
import script from "./imports copy.vue?vue&type=script&lang=js&"
export * from "./imports copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc09292",
  null
  
)

export default component.exports